export class LeadsDashBoardCount{
    totalLeads: number;
    currentLeads: number;
    patients: number;

    constructor(totalLeads: number, currentLeads: number, patients: number) {
        this.totalLeads = totalLeads;
        this.currentLeads = currentLeads;
        this.patients = patients;
    }
}

